import { name, version } from '../package.json';

export default {
    onDark: {
        type: Boolean,
        default: false,
    },
    size: {
        type: String,
        default: 'medium',
        validator(value) {
            return ['small', 'medium', 'large', 'touch'].indexOf(value) !== -1;
        },
    },
    text: {
        type: String,
    },
    version: {
        type: String,
        default: `${name}-${version}`,
    },
};
